import { defineComponent } from 'vue';

const name = 'g-pdf'

export default defineComponent({
  name,

  components: { }, 

  props: { 
    executar: {
      type: Number,
      default: 0
    },
    nomeArquivo: {
      type: String, 
      default: "Arquivo_PDF"
    },
    fazDownload: {
      type: Boolean,
      default: false
    },
    formatoPDF: {
      type: String,
      default: "a4"
    },
    orientacaoPDF: {
      type: String,
      default: "portrait"
    },
    pdfFloat: {
      type: Boolean,
      default: false
    },
    NovaGuia: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Boolean,
      default: true,
    }
  },

  mounted () {},

  updated () {},

  data () {
    return {
      pdf: false,
    }  
  },

  methods: { 
    generatePdf() {
      this.$refs.referenciaInterna.generatePdf(); 
    },

    abrirNovaGuia(obj) {
      if(this.fazDownload) {
        this.ligaDownload()
      } 

      if (this.pdfFloat == false && this.NovaGuia == true) {
        this.$isLoading(true)

        if(this.timeout){
          setTimeout(() => {
            this.montarPdf(obj);
          }, 1000);
        }
        else {
          this.montarPdf(obj);
        }
      }    

      this.$isLoading(false)
    },
  
    async ligaDownload() {
      this.downloadOn = true
    },

    montarPdf(obj) {
      let gcard = obj.pdfContent.querySelector('.g-card')
      
      if(gcard !== null && gcard !== undefined)  
        obj.pdfContent.querySelector('.g-card')

      obj.html2pdf()
        .from(obj.pdfContent)
        .toPdf()
        .get('pdf')
        // .save(this.nomeArquivo + '.pdf')
        .then(function (pdf) {
          var blob = pdf.output("blob");
          window.open(URL.createObjectURL(blob));

          // window.open(pdf.output('bloburl'), '_blank')
      });
    },
  },

  computed: {}, 

  watch: {
    executar(){
      this.generatePdf() 
    }
  }   
});